import moment from "moment";

export const licenseTimeShowFormat = "YYYY-MM-DD";

export const parseLicenseTime = (time) =>
  moment(time).utc().format(licenseTimeShowFormat);
